module.exports = __webpack_public_path__ + "static/img/tongue_left.png";